import React from 'react';
import { Hero } from '../components/Hero';
import { FeaturedEpisodes } from '../components/FeaturedEpisodes';
import { AboutHosts } from '../components/AboutHosts';
import { FoundersCarousel } from '../components/FoundersCarousel';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <main className="min-h-screen bg-archival-cream text-charcoal-900 selection:bg-gold/30 selection:text-charcoal-900" data-id="element-203">
      <div className="film-grain" aria-hidden="true" data-id="element-204" />

      <Hero data-id="element-205" />
      <FeaturedEpisodes data-id="element-206" />
      <AboutHosts data-id="element-207" />
      <FoundersCarousel data-id="element-208" />
      <Footer data-id="element-209" />
    </main>;
}